import { Text, TextProps } from "@chakra-ui/react";
import { RefObject, useRef } from "react";

export function ContentEditable({
  passedEditableRef,
  children,
  enabled,
  handleSubmit,
  ...props
}: {
  passedEditableRef?: RefObject<HTMLDivElement>;
  children?: React.ReactNode;
  enabled?: boolean;
  handleSubmit?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
} & TextProps) {
  const editableRef = useRef<HTMLDivElement>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key !== "Enter") return;
    e.preventDefault();
    if (e.ctrlKey) {
      document.execCommand("insertLineBreak");
      return;
    }
    handleSubmit?.(e);
  };

  // Strip inline font/color/bg styles from pasted HTML so the input keeps
  // its own typography. We preserve structure (line breaks, links, etc.).
  const handlePaste = (e: React.ClipboardEvent<HTMLDivElement>) => {
    const html = e.clipboardData.getData("text/html");
    const text = e.clipboardData.getData("text/plain");
    e.preventDefault();

    if (!html) {
      document.execCommand("insertText", false, text);
      return;
    }

    const container = document.createElement("div");
    container.innerHTML = html;
    container.querySelectorAll("*").forEach((el) => {
      el.removeAttribute("style");
      el.removeAttribute("class");
      el.removeAttribute("color");
      el.removeAttribute("bgcolor");
      el.removeAttribute("face");
      el.removeAttribute("size");
    });
    document.execCommand("insertHTML", false, container.innerHTML);
  };

  return (
    <Text
      ref={passedEditableRef || editableRef}
      contentEditable={enabled}
      suppressContentEditableWarning
      onKeyDown={handleKeyDown}
      onPaste={handlePaste}
      {...props}
    >
      {children}
    </Text>
  );
}
